<div class="date-picker" :class="classes">
    <input class="date-picker__input" type="text"
        :disabled="disabled"
        :placeholder="placeholder" data-input ref="datePickerInput" />

    <a class="date-picker__action-button" data-toggle
        title="toggle" v-if="withActionButtons">
        <mom-icon class="date-picker__icon" svgIcon="calendar"></mom-icon>
    </a>

    <a class="date-picker__action-button" title="clear" data-clear
        v-if="withActionButtons && clearAction">
        <mom-icon class="date-picker__icon" svgIcon="clear"></mom-icon>
    </a>
</div>
